import { create } from 'zustand';

type ItemPanelContentType = 'item-create' | 'item-details' | 'help' | null;

interface LabourItemUIState {
  isPanelOpen: boolean;
  panelContent: ItemPanelContentType;
  selectedItemId: string | null;
  addItemFormName: string;
  setAddItemFormName: (name: string) => void;
  openItemCreatePanel: () => void;
  openItemDetails: (itemId: string) => void;
  openHelp: () => void;
  closePanel: () => void;
}

const closedState = {
  isPanelOpen: false,
  panelContent: null as ItemPanelContentType,
  selectedItemId: null,
  addItemFormName: '',
};

export const useLabourItemUIStore = create<LabourItemUIState>(set => ({
  ...closedState,
  setAddItemFormName: addItemFormName => set({ addItemFormName }),
  openItemCreatePanel: () =>
    set({
      isPanelOpen: true,
      panelContent: 'item-create',
      selectedItemId: null,
      addItemFormName: '',
    }),
  openItemDetails: selectedItemId =>
    set({
      isPanelOpen: true,
      panelContent: 'item-details',
      selectedItemId,
      addItemFormName: '',
    }),
  openHelp: () =>
    set({
      isPanelOpen: true,
      panelContent: 'help',
      selectedItemId: null,
      addItemFormName: '',
    }),
  closePanel: () => set(closedState),
}));
